import { useMutation } from '@tanstack/react-query'
import { faceAuthentication } from '..'

const useFaceAuthentication = () =>
  useMutation({
    mutationFn: faceAuthentication,
  })

export default useFaceAuthentication
